import { ValueOf } from '../utilities/types';

const actions = {
  ACCOUNT_ENTITY_CREATE: 'AccountEntityCreate',
  ACCOUNT_ENTITY_GET: 'AccountEntityGet',
  ACCOUNT_ENTITY_LIST: 'AccountEntityList',
  ACCOUNT_ENTITY_UPDATE: 'AccountEntityUpdate',
  ACCOUNT_SECURITY_UPDATE: 'AccountSecurityUpdate',
  ANALYSIS_CREATE: 'AnalysisCreate',
  ANALYSIS_GET: 'AnalysisGet',
  ANALYSIS_REVISE: 'AnalysisRevise',
  ANALYSIS_ADD_TO_COMMENTS: 'AnalysisAddToComments',
  API_KEY_CREATE: 'ApiKeyCreate',
  API_KEY_GET_SECRET: 'ApiKeyGetSecret',
  API_KEY_GET: 'ApiKeyGet',
  API_KEY_LIST: 'ApiKeyList',
  API_KEY_UPDATE: 'ApiKeyUpdate',
  AUDIT_TRACK_LIST: 'AuditTrackList',
  BANK_DATA_GET_CATEGORIZATION: 'BankDataGetCategorization',
  BUSINESS_CREATE_ADVERSE_MEDIA: 'BusinessCreateAdverseMedia',
  BUSINESS_CREATE_COMPANY_REP: 'BusinessCreateCompanyRep',
  BUSINESS_CREATE_CREDIT: 'BusinessCreateCredit',
  BUSINESS_CREATE_EXPOSURE: 'BusinessCreateExposure',
  BUSINESS_CREATE_FINANCIAL_DATA: 'BusinessCreateFinancialData',
  BUSINESS_CREATE_GENERAL_INFO: 'BusinessCreateGeneralInfo',
  BUSINESS_CREATE_IP_ADDRESS: 'BusinessCreateIpAddress',
  BUSINESS_CREATE_OWNERSHIP: 'BusinessCreateOwnership',
  BUSINESS_CREATE_SANCTION_LIST_COMPANY: 'BusinessCreateSanctionListCompany',
  BUSINESS_CREATE: 'BusinessCreate',
  BUSINESS_GET_ADVERSE_MEDIA: 'BusinessGetAdverseMedia',
  BUSINESS_GET_COMPANY_REP: 'BusinessGetCompanyRep',
  BUSINESS_GET_CREDIT: 'BusinessGetCredit',
  BUSINESS_GET_EXPOSURE: 'BusinessGetExposure',
  BUSINESS_GET_FINANCIAL_DATA: 'BusinessGetFinancialData',
  BUSINESS_GET_GENERAL_INFO: 'BusinessGetGeneralInfo',
  BUSINESS_GET_IP_ADDRESS: 'BusinessGetIpAddress',
  BUSINESS_GET_OWNERSHIP: 'BusinessGetOwnership',
  BUSINESS_GET_SANCTION_LIST_COMPANY: 'BusinessGetSanctionListCompany',
  BUSINESS_GET_TRANSACTIONS: 'BusinessGetTransactions',
  BUSINESS_GET: 'BusinessGet',
  BUSINESS_LIST: 'BusinessList',
  BUSINESS_UPDATE: 'BusinessUpdate',
  CAR_CREATE_BASIC_DATA: 'CarCreateBasic',
  CAR_CREATE_EXEMPTION_DATA: 'CarCreateExemption',
  CAR_CREATE_PREVIOUS_OWNERS_DATA: 'CarCreatePreviousOwner',
  CAR_CREATE_TECHNICAL_DATA: 'CarCreateTechnical',
  CAR_CREATE_VEHICLE_INSPECTION_DATA: 'CarCreateVehicleInspection',
  CAR_CREATE: 'CarCreate',
  CAR_GET_BASIC_DATA: 'CarGetBasic',
  CAR_GET_EXEMPTION_DATA: 'CarGetExemption',
  CAR_GET_PREVIOUS_OWNERS_DATA: 'CarGetPreviousOwner',
  CAR_GET_TECHNICAL_DATA: 'CarGetTechnical',
  CAR_GET_VEHICLE_INSPECTION_DATA: 'CarGetVehicleInspection',
  CAR_GET: 'CarGet',
  CAR_LIST: 'CarList',
  CAR_UPDATE: 'CarUpdate',
  CASE_ADD_COMMENT: 'CaseAddComment',
  CASE_DELETE_COMMENT: 'CaseDeleteComment',
  CASE_ASSIGN: 'CaseAssign',
  CASE_CREATE: 'CaseCreate',
  CASE_DOWNLOAD: 'CaseDownload',
  CASE_ESCALATE: 'CaseEscalate',
  CASE_GET_STATUS_BREAKDOWN: 'CaseGetStatusBreakdown',
  CASE_GET: 'CaseGet',
  CASE_LIST: 'CaseList',
  CASE_SUMMARY_CREATE: 'CaseSummaryCreate',
  CASE_MANAGE_ENTITIES: 'CaseManageEntities',
  CASE_TRANSACTION_SNAPSHOT_CREATE: 'CaseTransactionSnapshotCreate',
  CASE_TRANSACTION_SNAPSHOT_DELETE: 'CaseTransactionSnapshotDelete',
  CASE_TRANSACTION_SNAPSHOT_GET: 'CaseTransactionSnapshotGet',
  CASE_TRANSACTION_SNAPSHOT_LIST: 'CaseTransactionSnapshotList',
  CASE_UPDATE_PRIORITY: 'CaseUpdatePriority',
  CASE_UPDATE_STATUS: 'CaseUpdateStatus',
  CASE_UPDATE: 'CaseUpdate',
  CONNECTION_CREATE: 'ConnectionCreate',
  CONNECTION_LIST: 'ConnectionList',
  DATA_POINT_CREATE: 'DataPointCreate',
  DATA_POINT_GET: 'DataPointGet',
  DATA_POINT_LIST: 'DataPointList',
  DATA_POINT_UPDATE: 'DataPointUpdate',
  DEVICE_USAGE_LIST: 'DeviceUsageList',
  FORM_ANSWER_GET: 'FormAnswerGet',
  FORM_ANSWER_SUBMIT: 'FormAnswerSubmit',
  FORM_ANSWER_UPDATE: 'FormAnswerUpdate',
  FORM_CREATE: 'FormCreate',
  FORM_GET_LINK: 'FormGetLink',
  FORM_GET: 'FormGet',
  FORM_LIST: 'FormList',
  FORM_STUDIO_ACCESS: 'FormStudioAccess',
  FORM_UPDATE: 'FormUpdate',
  GROUP_CREATE: 'GroupCreate',
  GROUP_GET: 'GroupGet',
  GROUP_HISTORY_LIST: 'GroupHistoryList',
  GROUP_LIST: 'GroupList',
  GROUP_UPDATE_ACTIVATION: 'GroupUpdateActivation',
  GROUP_UPDATE: 'GroupUpdate',
  INDIVIDUAL_CREATE_ADVERSE_MEDIA: 'IndividualCreateAdverseMedia',
  INDIVIDUAL_CREATE_BUSINESS_ASSOCIATION: 'IndividualCreateBusinessAssociation',
  INDIVIDUAL_CREATE_CREDIT: 'IndividualCreateCredit',
  INDIVIDUAL_CREATE_IP_ADDRESS: 'IndividualCreateIpAddress',
  INDIVIDUAL_CREATE_LEGAL_SCORE: 'IndividualCreateLegalScore',
  INDIVIDUAL_CREATE_PEP: 'IndividualCreatePEP',
  INDIVIDUAL_CREATE_SANCTION_LIST: 'IndividualCreateSanctionList',
  INDIVIDUAL_CREATE_SPAR: 'IndividualCreateSpar',
  INDIVIDUAL_CREATE: 'IndividualCreate',
  INDIVIDUAL_GET_ADVERSE_MEDIA: 'IndividualGetAdverseMedia',
  INDIVIDUAL_GET_BUSINESS_ASSOCIATION: 'IndividualGetBusinessAssociation',
  INDIVIDUAL_GET_CREDIT: 'IndividualGetCredit',
  INDIVIDUAL_GET_IP_ADDRESS: 'IndividualGetIpAddress',
  INDIVIDUAL_GET_LEGAL_SCORE: 'IndividualGetLegalScore',
  INDIVIDUAL_GET_PEP: 'IndividualGetPEP',
  INDIVIDUAL_GET_SANCTION_LIST: 'IndividualGetSanctionList',
  INDIVIDUAL_GET_SPAR: 'IndividualGetSpar',
  INDIVIDUAL_GET_TRANSACTIONS: 'IndividualGetTransactions',
  INDIVIDUAL_GET: 'IndividualGet',
  INDIVIDUAL_LIST: 'IndividualList',
  INDIVIDUAL_UPDATE: 'IndividualUpdate',
  INTERFACE_SETTINGS_LIST: 'InterfaceSettingsList',
  IP_USAGE_LIST: 'IpUsageList',
  MEMBER_CREATE: 'MemberCreate',
  MEMBER_GET: 'MemberGet',
  MEMBER_INITIATE_MFA_RESET: 'MemberInitiateMfaReset',
  MEMBER_INITIATE_RESET: 'MemberInitiateRest',
  MEMBER_LIST: 'MemberList',
  MEMBER_UPDATE_ACTIVATION: 'MemberUpdateActivation',
  MEMBER_UPDATE: 'MemberUpdate',
  PERMISSION_ROLE_CREATE: 'PermissionRoleCreate',
  PERMISSION_ROLE_GET: 'PermissionRoleGet',
  PERMISSION_ROLE_LIST: 'PermissionRoleList',
  PERMISSION_ROLE_UPDATE: 'PermissionRoleUpdate',
  PERMISSION_ROLE_DELETE: 'PermissionRoleDelete',
  PING_ADD_COMMENT: 'PingAddComment',
  PING_DELETE_COMMENT: 'PingDeleteComment',
  PING_CREATE: 'PingCreate',
  PING_GET: 'PingGet',
  PING_LIST: 'PingList',
  PING_UPDATE_STATUS: 'PingUpdateStatus',
  PING_UPDATE: 'PingUpdate',
  PINGU_CHAT_USE: 'PinguChatUse',
  PROCESS_CREATE: 'ProcessCreate',
  PROCESS_GET: 'ProcessGet',
  PROCESS_LIST: 'ProcessList',
  PROCESS_UPDATE_ACTIVATION: 'ProcessUpdateActivation',
  PROCESS_UPDATE: 'ProcessUpdate',
  PRODUCT_CREATE: 'ProductCreate',
  PRODUCT_GET: 'ProductGet',
  PRODUCT_LIST: 'ProductList',
  PRODUCT_UPDATE: 'ProductUpdate',
  PROVIDER_MANAGEMENT: 'ProviderManagement',
  REPORT_CREATE: 'ReportCreate',
  REPORT_DOWNLOAD: 'ReportDownload',
  REPORT_GET: 'ReportGet',
  REPORT_LIST: 'ReportList',
  REQUEST_ADD_COMMENT: 'RequestAddComment',
  REQUEST_DELETE_COMMENT: 'RequestDeleteComment',
  REQUEST_CREATE: 'RequestCreate',
  REQUEST_GET: 'RequestGet',
  REQUEST_LIST: 'RequestList',
  REQUEST_REPROCESS: 'RequestReprocess',
  REQUEST_UPDATE_RECOMMENDATION: 'RequestUpdateRecommendation',
  REQUEST_UPDATE: 'RequestUpdate',
  RESOLUTION_HISTORY_CREATE: 'resolutionHistoryCreate',
  RESOLUTION_HISTORY_GET: 'resolutionHistoryGet',
  RESOLUTION_HISTORY_LIST: 'resolutionHistoryList',
  RESOLUTION_HISTORY_UPDATE: 'resolutionHistoryUpdate',
  RISK_CLASS_CREATE: 'RiskClassCreate',
  RISK_CLASS_DELETE: 'RiskClassDelete',
  RISK_CLASS_GET: 'RiskClassGet',
  RISK_CLASS_LIST: 'RiskClassList',
  RISK_CLASS_UPDATE: 'RiskClassUpdate',
  RULE_CREATE: 'RuleCreate',
  RULE_DELETE: 'RuleDelete',
  RULE_GET: 'RuleGet',
  RULE_LIST: 'RuleList',
  RULE_UPDATE: 'RuleUpdate',
  RULE_VERSION_APPROVE: 'RuleVersionApprove',
  RULE_VERSION_LIST: 'RuleVersionList',
  RULE_VERSION_PUBLISH: 'RuleVersionPublish',
  RULE_VERSION_RELEASE: 'RuleVersionRelease',
  SCORE_LIST: 'ScoreList',
  SIGNAL_CREATE: 'SignalCreate',
  SIGNAL_GET: 'SignalGet',
  SIGNAL_LIST: 'SignalList',
  SIGNAL_UPDATE_ACTIVATION: 'SignalUpdateActivation',
  SIGNAL_UPDATE: 'SignalUpdate',
  TAG_CREATE: 'TagCreate',
  TAG_GET: 'TagGet',
  TAG_LIST: 'TagList',
  TAG_UPDATE_ACTIVATION: 'TagUpdateActivation',
  TAG_UPDATE: 'TagUpdate',
  TEAM_CREATE: 'TeamCreate',
  TEAM_GET: 'TeamGet',
  TEAM_LIST: 'TeamList',
  TEAM_UPDATE_ACTIVATION: 'TeamUpdateActivation',
  TEAM_UPDATE: 'TeamUpdate',
  TRANSACTION_TABLE_SETUP_GET: 'TransactionTableSetupGet',
  TRANSACTION_TABLE_SETUP_UPDATE_COLUMNS: 'TransactionTableSetupUpdateColumns',
  TRANSACTION_TABLE_SETUP_UPDATE_ROW: 'TransactionTableSetupUpdateRows',
  TRANSACTION_TYPE_CREATE: 'TransactionTypeCreate',
  TRANSACTION_TYPE_GET: 'TransactionTypeGet',
  TRANSACTION_TYPE_LIST: 'TransactionTypeList',
  TRANSACTION_TYPE_UPDATE_ACTIVATION: 'TransactionTypeUpdateActivation',
  TRANSACTION_TYPE_UPDATE: 'TransactionTypeUpdate',
  WEBHOOK_CONFIGURATION_MANAGE: 'WebhookConfigurationManage',
  WEBHOOK_CONFIGURATION_VIEW: 'WebhookConfigurationView',
  WEBHOOK_TRIGGER_TEST: 'WebhookTriggerTest',
} as const;

export type Actions = ValueOf<typeof actions>;

export default actions;
